import { useEffect } from 'react';
import { usePrevious } from '../../../hooks';

function useStoreChangeAffect({ store, storeChangeAffect, onChange }) {
  const prevStore = usePrevious(store);

  useEffect(() => {
    if (storeChangeAffect) {
      if (prevStore && prevStore !== store) {
        onChange();
      }
    }
  }, [store]);
}

export default useStoreChangeAffect;
